import React from 'react'
import { AuthContext } from '../auth-provider'

/**
 * HOC para componentes de clase legacy.
 * Inyecta el contexto de auth como prop `auth` y opcionalmente props mapeadas.
 */
export function withAuth (WrappedComponent, mapAuthToProps) {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component'

  class WithAuth extends React.Component {
    render () {
      return (
        <AuthContext.Consumer>
          {(auth) => (
            <WrappedComponent
              {...this.props}
              auth={auth}
              {...(mapAuthToProps ? mapAuthToProps(auth, this.props) : {})}
            />
          )}
        </AuthContext.Consumer>
      )
    }
  }

  WithAuth.displayName = `withAuth(${displayName})`

  return WithAuth
}

export default withAuth
